import client from 'webpack-theme-color-replacer/client'
import forElementUI from 'webpack-theme-color-replacer/forElementUI'
import { generate } from '@ant-design/colors'

export function changeThemeColor(
  themeList = ['#1890ff', '#ff4d4f'],
  otherList = ['#1890ff', '#a7d5ff', '#d8ebff', '#edf6ff', '#f8f9fb']
) {
  const colorTemp = []
  themeList.forEach(value => {
    colorTemp.push(...forElementUI.getElementUISeries(value))
    colorTemp.push(...generate(value))
  })
  colorTemp.push(...otherList)

  client.changer
    .changeColor(
      {
        newColors: colorTemp,
        changeUrl(cssUrl) {
          return `/${cssUrl}`
        }
      },
      Promise
    )
    .catch(err => {
      //
    })
}
